import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=c63c31e0&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c63c31e0')) {
      api.createRecord('c63c31e0', component.options)
    } else {
      api.reload('c63c31e0', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=c63c31e0&", function () {
      api.rerender('c63c31e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/employees/Info.vue"
export default component.exports